import React from 'react';
import { WalletIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useBillingCart } from '../../context/BillingCartContext';
export function WalletBadge() {
  const navigate = useNavigate();
  const {
    walletBalance
  } = useBillingCart();
  return <button onClick={() => navigate('/settings/billing')} className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-lg hover:from-emerald-100 hover:to-teal-100 transition-all group" data-id="element-431">
      <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center" data-id="element-432">
        <WalletIcon size={14} className="text-white" data-id="element-433" />
      </div>
      <div className="text-left" data-id="element-434">
        <p className="text-[10px] text-emerald-600 font-medium leading-none" data-id="element-435">
          Media Wallet
        </p>
        <p className="text-sm font-bold text-emerald-800" data-id="element-436">
          ₹
          {walletBalance.toLocaleString('en-IN', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}
        </p>
      </div>
    </button>;
}